<ng-container *notInProductCode="[productCode.Partners]">
  <div class="full-page-container">
    <div class="d-lg-block d-none">
      <fgb-banner [title]="'lotto.page.title' | translate"></fgb-banner>
    </div>
    <fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>

    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

    <div class="container mt-4">
      <fgbcl-lottos-list [isList]="true"></fgbcl-lottos-list>
    </div>
  </div>
</ng-container>

<ng-container *inProductCode="[productCode.Partners]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
